import React from 'react';
import PropTypes from 'prop-types';
import WIDGET_LABELS from '../../constants/widgetLabels';
import {
  Overlay,
  Panel,
  PanelHeader,
  PanelTitle,
  CloseButton,
  WidgetList,
  EmptyMessage,
  WidgetItem,
  WidgetItemLabel,
  AddButton
} from './styled';

const WidgetPicker = ({ availableWidgets, onAdd, onClose }) => (
  <>
    <Overlay onClick={ onClose } />
    <Panel onClick={ e => e.stopPropagation() }>
      <PanelHeader>
        <PanelTitle>Add Widget</PanelTitle>
        <CloseButton onClick={ onClose }>✕</CloseButton>
      </PanelHeader>
      <WidgetList>
        {availableWidgets.length === 0
          ? (
            <EmptyMessage>All widgets are already on the dashboard.</EmptyMessage>
            )
          : availableWidgets.map(id => (
            <WidgetItem key={ id } onClick={ () => onAdd(id) }>
              <WidgetItemLabel>
                {WIDGET_LABELS[id] || id}
              </WidgetItemLabel>
              <AddButton onClick={ e => { e.stopPropagation(); onAdd(id); } }>
                +
              </AddButton>
            </WidgetItem>
          ))}
      </WidgetList>
    </Panel>
  </>
);

WidgetPicker.propTypes = {
  availableWidgets: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAdd: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default WidgetPicker;
